import { render } from "./KidsStoreNav.vue?vue&type=template&id=4b51dcd3&scoped=true"
import script from "./KidsStoreNav.vue?vue&type=script&lang=js"
export * from "./KidsStoreNav.vue?vue&type=script&lang=js"

import "./KidsStoreNav.vue?vue&type=style&index=0&id=4b51dcd3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b51dcd3"]])

export default __exports__